import React, { useEffect } from "react";
import Box from "@carrier-io/air-react/Box";
import { AdminHead } from "../../components/admin/AdminHead";
import { UserForm } from "../../components/userForm/UserForm";
import { useNavigate } from "react-router-dom";
import { useAlerts } from "../../contexts/alert/AlertsContext";
import { apollo, Clients, useMutation } from "../../apollo";
import { UpdateUserMutation } from "../../graphql/mutations/updateUser";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { UserInputUpdate } from "../../validations/userEditValidation";
import { useForm } from "react-hook-form";
import { DEFAULT_REGION } from "../../constants/regions";
import { AlertTypes } from "../../contexts/alert/types";
import { displayError } from "../../constants/error";
import { useUser } from "../../contexts/user/userContext";

export const UpdateProfile = () => {
  const navigate = useNavigate();
  const { pushAlert } = useAlerts();
  const { user: existingUser } = useUser();

  const [updateUser, { loading }] = useMutation(
    Clients.UPS,
    UpdateUserMutation,
  );

  const resolver = classValidatorResolver(UserInputUpdate);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
  } = useForm<UserInputUpdate>({
    mode: "onBlur",
    resolver,
    defaultValues: {
      firstName: "",
      lastName: "",
    },
  });

  useEffect(() => {
    if (existingUser) {
      reset({
        firstName: existingUser.firstName,
        lastName: existingUser.lastName,
      });
    }
  }, [existingUser, reset]);

  const handleSaveUser = async (data: UserInputUpdate) => {
    const attributes = data.attributes?.reduce(
      (acc, item) => {
        if (item.key && item.value) {
          acc[item.key] = item.value;
        }
        return acc;
      },
      {} as Record<string, string>,
    );

    const modifiedUser = {
      ...data,
      attributes,
    };

    try {
      await updateUser({
        variables: {
          username: existingUser.username,
          input: modifiedUser,
          region: DEFAULT_REGION,
        },
      });
      pushAlert(AlertTypes.SUCCESS, "User updated successfully");
    } catch (error) {
      pushAlert(
        AlertTypes.ERROR,
        displayError((error as apollo.ApolloError).graphQLErrors[0]),
      );
    }
  };
  return (
    <>
      <AdminHead title="Your Profile" />
      <Box sx={{ padding: "24px 32px 40px", maxWidth: "922px" }}>
        <UserForm
          control={control}
          errors={errors}
          onSubmit={handleSubmit(handleSaveUser)}
          loading={loading}
          onCancel={() => navigate(-1)}
          isValid={isDirty}
          submitButtonText="Save Changes"
          showAuthMethod={false}
          showUserBasicInfo={false}
          showUserRoleAndGroup={false}
          showUpdateUserInfo={true}
          showUserAdditionalAttributes={false}
        />
      </Box>
    </>
  );
};
